import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class FindherScene extends MinigameScene {
    //Images

    //values
    private maxCardXDifference = 213;
    private maxCardRotation = 20;
    private cardReturnTime = 250;

    private cardsConfig = [
        {cardImage: CONST.FINDHER.CUTIE_2, mustLike: true, failImage: CONST.FINDHER.WRONG_1, isFinal: true},
        {cardImage: CONST.FINDHER.ZOIDBERG, mustLike: true, failImage: CONST.FINDHER.WRONG_4, isFinal: false},
        {cardImage: CONST.FINDHER.CUTIE_3, mustLike: true, failImage: CONST.FINDHER.WRONG_1, isFinal: false},
        {cardImage: CONST.FINDHER.NOTCUTE_2, mustLike: false, failImage: CONST.FINDHER.WRONG_3, isFinal: false},
        {cardImage: CONST.FINDHER.NOTCUTE_1, mustLike: false, failImage: CONST.FINDHER.WRONG_2, isFinal: false},
        {cardImage: CONST.FINDHER.CUTIE_1, mustLike: true, failImage: CONST.FINDHER.WRONG_1, isFinal: false},
    ]

    private animFPS = 45;

    //logic vars
    private cards = [];
    private currentCard = 0;
    private animTimer = 0;
    private isAnimating = false;

    constructor(){
        super ({
            sceneName: CONST.SCENES.FINDHER,
            duration: 20000,
            startScreenColor: 0xE6FB9D,
            startText: "DATE!",
            startTextColor: 0x323232,
            nextScene: CONST.SCENES.BEERPONG,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 416, scale: 1.30},
                normalWithSkip: {x: 319, y: 418, scale: 1.0},
                skip: {x: 534, y: 418, scale: 1.0}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.cards = [];
        this.animTimer = 0;
        this.isAnimating = false;
        this.currentCard = 0;
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.FINDHER.FOREGROUND).setOrigin(0, 0).setDepth(90);
        this.add.image(426.5, 240, CONST.FINDHER.WHITEBACKGROUND);

        let likeButton = this.add.image(489, 416, CONST.PUBERTY.PIMPLE)
        .setScale(1.1, 1.1)
        .setDepth(80)
        .setInteractive({ useHandCursor: true });

        likeButton.on("pointerdown", () => {
            if (this.currentCard < 0) return;
            this.cards[this.currentCard].timer = 3 * this.cardReturnTime;
            this.cards[this.currentCard].fullTimer = this.cards[this.currentCard].timer;
            this.likeCard(true, this.cards[this.currentCard]);
        }, this);

        let dislikeButton = this.add.image(370, 416, CONST.PUBERTY.PIMPLE)
        .setScale(1.1, 1.1)
        .setDepth(80)
        .setInteractive({ useHandCursor: true });

        dislikeButton.on("pointerdown", () => {
            if (this.currentCard < 0) return;
            this.cards[this.currentCard].timer = 3 * this.cardReturnTime;
            this.cards[this.currentCard].fullTimer = this.cards[this.currentCard].timer;
            this.likeCard(false, this.cards[this.currentCard]);
        }, this);


        this.createCards();

        this.endAnimation = this.cache.json.get(CONST.ANIMATIONS.FINDHEREND);
    }

    private likeCard(liked: boolean, card: object){
                card.tempPosition = {x: card.x, y: card.y};

                card.liked = liked;
                card.isActive = false;

                if (liked){
                    if (!card.config.mustLike){
                        this.triggerLose(card.config.failImage);
                    } else if (card.config.isFinal){
                        this.triggerWin();
                    }
                } else {
                    if (card.config.mustLike){
                        this.triggerLose(card.config.failImage);
                    }
                }

                this.currentCard--;
    }

    private createCards(){
        this.cardsConfig.forEach((cardConfig) => {
            var card = this.add.image(426.5, 220, cardConfig.cardImage)
                                .setInteractive({ useHandCursor: true });
            card.likeImage = this.add.image(282.5 - card.x, 127.5 - card.y, CONST.FINDHER.LIKE_OVERLAY).setAngle(-25).setScale(0.75);
            card.nopeImage = this.add.image(562.4 - card.x, 133.3 - card.y, CONST.FINDHER.NOPE_OVERLAY).setAngle(25).setScale(0.75);

            card.content = this.add.container(card.x, card.y, [card.likeImage, card.nopeImage]);

            card.config = cardConfig;
            card.rotationMultiplier = this.maxCardRotation / this.maxCardXDifference;
            card.tempPosition = {x: card.x, y: card.y};
            card.timer = 0;
            card.fullTimer = 250;

            card.isDragging = false;
            card.isActive = true;
            card.liked = false;

            this.cards.push(card);

            this.input.setDraggable(card);

            card.update = (delta: number, card: object) => {
                var xOffset = -(card.x - 426.5);
                //Set angle
                card.setAngle(xOffset * card.rotationMultiplier);
                card.content.setAngle(card.angle);

                //set overlay transparency
                card.likeImage.setAlpha(-xOffset/186);
                card.nopeImage.setAlpha(+xOffset/186);

                if (!card.isDragging && card.timer >= 0){
                    card.timer -= delta;
                    if (card.isActive){
                        card.x = Phaser.Math.Interpolation.SmoothStep(card.timer/card.fullTimer, 426.5, card.tempPosition.x);
                        card.y = Phaser.Math.Interpolation.SmoothStep(card.timer/card.fullTimer, 220, card.tempPosition.y);    
                    } else {
                        card.x = Phaser.Math.Interpolation.SmoothStep(card.timer/card.fullTimer, card.liked ? 959 : -106, card.tempPosition.x);
                    }

                    card.content.x = card.x;
                    card.content.y = card.y;
                }
            }
        });

        this.input.on('dragstart', function (pointer, gameObject) {
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;

            gameObject.isDragging = true;
            gameObject.timer = this.cardReturnTime;
            gameObject.fullTimer = gameObject.timer;
        }, this);

        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;

            gameObject.x = dragX;
            gameObject.y = dragY;

            gameObject.content.x = dragX;
            gameObject.content.y = dragY;
        }, this);

        this.input.on('dragend', function(pointer, gameObject, dropped){
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            if (!gameObject.isActive) return;

            gameObject.isDragging = false;
            gameObject.tempPosition = {x: gameObject.x, y: gameObject.y};

            if (gameObject.x > 586){
                this.likeCard(true, gameObject);

            } else if (gameObject.x < 266){
                this.likeCard(false, gameObject);
            }
        }, this);

        this.currentCard = this.cards.length - 1;
    }

    _update(time: number, delta: number){
        if (this.isAnimating){
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }

       // if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.cards.forEach((c) => {c.update(delta, c)});
    }

    _timeout(){
        this.triggerLose(CONST.FINDHER.WRONG_1);
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(2000);
        this.endGameAnim();
    }

    private triggerLose(failImage: string){
        this.add.image(0,0, failImage).setOrigin(0,0).setDepth(1000);
        this.loseGame();
    }

    private endGameAnim(){
        this.endImage = this.add.image(0, 0, CONST.FINDHER.WINIMAGE).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }

    private positionImageOnAnimation(timer: number, image: Phaser.GameObjects.Image, animation: object, xOffset: number = 0, yOffset: number = 0, angleOffset: number = 0, scaleMultiplier: number = 1){
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length){
            frameIndex = animation.frames.length - 1;
        }

        var frame = animation.frames[frameIndex];

        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset)
            .setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier)
            .setAngle(parseFloat(frame.angle) + angleOffset);
    }
}
